<div class="header">
    <ng-container *ngFor="let tab of EDITOR_TAB; index as i">
        <ng-container *ngIf="!tabIsDisabled(tab)"
            ><div
                class="tab"
                data-cy="mimics-right-side-panel-tab-name"
                [class.disabled]="tabIsDisabled(tab)"
                [class.select]="selectedMenu === tab"
                (click)="tabClick(tab)">
                {{ tab | translate }}
            </div>
        </ng-container>
    </ng-container>
</div>

<div class="main">
    <div class="scroll-wrapper">
        <ng-container *ngIf="designTabIsOpen()">
            <app-design-side-menu
                [selectedMimic]="selectedMimic"
                [selectedEntity]="selectedEntity"
                [selectedElements]="selectedElements"
                [rootList]="rootList">
            </app-design-side-menu>
        </ng-container>
        <ng-container *ngIf="settingsTabIsOpen()">
            <app-settings-side-menu
                style="height: 100%"
                #settingsMenu
                [mimicId]="selectedMimic?.id"
                [selectedElement]="selectedElements[0]"
                [userCanEdit]="userCanEdit"
                [libraryList]="libraryList"></app-settings-side-menu>
        </ng-container>
    </div>
</div>

<app-confirmation-window
    #exitSettingsConfirmation
    [mainLabel]="'mimic.settings.exit-confirmation.title'"
    [subLabel]="'mimic.settings.exit-confirmation.sub-label'"
    [discardLabel]="'mimic.settings.exit-confirmation.discard'"
    [goBackLabel]="'mimic.settings.exit-confirmation.go-back'"
    [saveLabel]="'mimic.settings.exit-confirmation.save'"></app-confirmation-window>
